import { FC } from 'react';
import { SkipSubscriptionDeliveryModalProps, Styled } from '.';
import Image from 'next/image';
import { Button, Modal } from 'components/core';
import { useI18n } from 'contexts/i18n';
import { useSkipSubscriptionDelivery } from 'reactQuery/mutations';

const SkipSubscriptionDeliveryModal: FC<SkipSubscriptionDeliveryModalProps> = ({
  subscriptionId,
  name,
  imageUrl,
  skipDeliveryDate,
  nextOccurrenceAt,
  onClose,
}) => {
  const i18n = useI18n();

  const skipSubscriptionDeliveryMutation = useSkipSubscriptionDelivery();

  const handleSkipDelivery = async () => {
    await skipSubscriptionDeliveryMutation.mutateAsync({
      subscriptionId: subscriptionId,
    });
    onClose();
  };
  return (
    <Modal>
      <Styled.CartItemContainer>
        <Styled.Header>
          <span>{i18n['Skip']}</span>
        </Styled.Header>
        <Styled.SkipText>
          {i18n['Skip your shipment for']} {nextOccurrenceAt}.
        </Styled.SkipText>
        <Styled.Body>
          <Styled.ModalBody>
            <Styled.Thumbnail>
              <Image
                src={imageUrl}
                alt="Prod Image"
                layout="fill"
                objectFit="cover"
                placeholder="blur"
                blurDataURL="data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImciPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjY2JjYmNiIiBvZmZzZXQ9IjIwJSIgLz4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2Y5ZjlmOSIgb2Zmc2V0PSI1MCUiIC8+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNjYmNiY2IiIG9mZnNldD0iNzAlIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3Qgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIGZpbGw9IiNjYmNiY2IiIC8+CiAgPHJlY3QgaWQ9InIiIHdpZHRoPSI3MDAiIGhlaWdodD0iNDc1IiBmaWxsPSJ1cmwoI2cpIiAvPgogIDxhbmltYXRlIHhsaW5rOmhyZWY9IiNyIiBhdHRyaWJ1dGVOYW1lPSJ4IiBmcm9tPSItNzAwIiB0bz0iNzAwIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgIC8+Cjwvc3ZnPg=="
              />
            </Styled.Thumbnail>
          </Styled.ModalBody>
          <Styled.ProductDetails>
            <div>{name}</div>
          </Styled.ProductDetails>
        </Styled.Body>
        <Styled.NextDeliveryText>
          {i18n['Your next shipment will be']} {skipDeliveryDate}.
        </Styled.NextDeliveryText>
        <Styled.Footer>
          <Styled.ButtonWrapper>
            <Button size="md" variant="secondary" onClick={onClose}>
              {i18n['Cancel']}
            </Button>
            <Button
              size="md"
              onClick={handleSkipDelivery}
              disabled={skipSubscriptionDeliveryMutation.isLoading}
              loading={skipSubscriptionDeliveryMutation.isLoading}
            >
              {i18n['Confirm']}
            </Button>
          </Styled.ButtonWrapper>
        </Styled.Footer>
      </Styled.CartItemContainer>
    </Modal>
  );
};

export default SkipSubscriptionDeliveryModal;
